

import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAPI } from "../Context/MyContext";
import ContactList from "./ContactList";
import ChatHeader from "./ChatHeader";
import MessageChat from "./MessageChat";
import MessageInput from "./MessageInput";
import VoiceRecorder from "./VoiceRecorder";
import { useStateContex } from "../Context/UseStateContet";
import toast from "react-hot-toast";



const ChatApp = () => {
  const [totalUnread, setTotalUnread] = useState(0);

  const [filter, setFilter] = useState("All");
  const { SendMessage, uploadMediatoGetID } = useAPI();
  const { selectedWabaId } = useStateContex()

  const [isAllowedToSendMessage, setIsAllowedToSendMessage] = useState(true)
  const [cswStatus, setCswStatus] = useState(null);
  const [replyMessage, setReplyMessage] = useState(null);

  const [selectedContact, setSelectedContact] = useState({
    id: null,
    name: null,
    number: null,
    phoneId: null,
  });

  // console.log("Selected Contact in ChatApp:", selectedContact);
  const [sessionWindows, setSessionWindows] = useState({});
  const [messages, setMessages] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const { register } = useForm();




  // ✅ Detect file type (for images/videos/docs)
  const getFileType = (file) => {
    const mimeType = file.type;
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    return "document";
  };

  // ✅ Send message (with optimistic UI update)
  const handleSendMessage = async (
    messageText,
    file = null,
    caption = "",
    type = "text",
    extraData = null // 👈 ADD THIS
  ) => {

    if (type === "template" && extraData) {
      try {
        const payload = {
          phone_number_id: selectedContact.phoneId,
          recipient_id: selectedContact.number,
           messageID: selectedContact.id,
          type: "template",
          ...extraData, // 👈 contains templateName, language, components
        };

        await SendMessage(payload);

        // Optional: show in UI
        const tempMessage = {
          _id: Date.now().toString(),
          content: `[TEMPLATE] ${extraData.templateName}`,
          sender: "user",
          createdAt: new Date().toISOString(),
          status: "sent",
          type: "template",
        };

        setMessages((prev) => ({
          ...prev,
          [selectedContact.id]: [
            ...(prev[selectedContact.id] || []),
            tempMessage,
          ],
        }));

      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to send template message");
        // console.error("Template send error:", error.response?.data || error.message);
      }

      return; // 👈 STOP further execution  
    }

    if (!messageText.trim() && !file) return;

    if (file && file.type.startsWith("audio/")) {
      // console.log("Audio handled separately in MessageInput");
      return;
    }



    const actualType = file ? getFileType(file) : type;
    const tempId = Date.now().toString();

    const tempMessage = {
      _id: tempId,
      content:
        actualType === "text"
          ? messageText
          : `[${actualType.toUpperCase()}] ${caption || file?.name || ""}`,
      sender: "user",
      createdAt: new Date().toISOString(),
      status: "sending",
      caption: caption || null,
      type: actualType,
      fileUrl: file ? URL.createObjectURL(file) : null,
    };

    // Optimistic update
    setMessages((prev) => ({
      ...prev,
      [selectedContact.id]: [...(prev[selectedContact.id] || []), tempMessage],
    }));
    setNewMessage("");

    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("caption", caption || "");
        formData.append("phone_number_id", selectedContact.phoneId);
        formData.append("recipient_id", selectedContact.number);
        formData.append("type", actualType);
        formData.append("wabaId", selectedWabaId)

        const result = await uploadMediatoGetID(formData);

        setMessages((prev) => {
          const updated = (prev[selectedContact.id] || []).map((msg) =>
            msg._id === tempId
              ? {
                ...msg,
                status: "sent",
                _id: result.newMessage?.message_id || tempId,
              }
              : msg
          );
          return { ...prev, [selectedContact.id]: updated };
        });
      } else {



        const dataToSend = {
          message: messageText,
          phone_number_id: selectedContact.phoneId,
          // recipient_id: selectedContact.number,
          messageID: selectedContact.id,
          type: "text",
          reply_to: replyMessage?.message_id || null
        };

        const response = await SendMessage(dataToSend);

        setMessages((prev) => {
          const updated = (prev[selectedContact.id] || []).map((msg) =>
            msg._id === tempId
              ? {
                ...msg,
                status: "sent",
                _id: response.tempMessage?.message_id || tempId,
              }
              : msg
          );
          return { ...prev, [selectedContact.id]: updated };
        });


      }
    } catch (error) {
      console.error("Failed to send message:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to send message");
      }
      setMessages((prev) => {
        const updated = (prev[selectedContact.id] || []).map((msg) =>
          msg._id === tempId
            ? { ...msg, status: "error", error: error.message }
            : msg
        );
        return { ...prev, [selectedContact.id]: updated };
      });
    }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <ContactList
        setTotalUnread={setTotalUnread}
        selectedContactId={selectedContact.id}
        setSelectedContactId={setSelectedContact}
        // filter={"All"}
        // setFilter={() => { }}
        filter={filter}
        setFilter={setFilter}

        register={register}
      />
      {selectedContact.id ? (
        <div className="flex-1 flex flex-col bg-[#e5ddd5] relative justify-between">
          <div
            className="absolute inset-0 opacity-10 pointer-events-none"
            style={{
              backgroundImage:
                "url('https://i.pinimg.com/originals/22/7c/68/227c68777d0c7790110ffe06384ead58.jpg')",
              backgroundRepeat: "repeat",
            }}
          />
          <ChatHeader
            contact={{ name: selectedContact.name }}
            number={selectedContact.number}
            phoneId={selectedContact.phoneId}
            messageID={selectedContact.id}
            recipientId={selectedContact.number}
          />
          {/* <MessageChat
            totalUnread={totalUnread}
            setIsAllowedToSendMessage={setIsAllowedToSendMessage}
            setCswStatus={setCswStatus}
            phoneId={selectedContact.phoneId}
            recipientId={selectedContact.number}
            messages={messages[selectedContact.id] || []}
          /> */}

          <MessageChat
            totalUnread={totalUnread}
            setIsAllowedToSendMessage={setIsAllowedToSendMessage}
            setCswStatus={setCswStatus}
            phoneId={selectedContact.phoneId}
            messageID={selectedContact.id}
            recipientId={selectedContact.number}
            messages={messages[selectedContact.id] || []}
            setReplyMessage={setReplyMessage}
          />
          <MessageInput
            onSendMessage={handleSendMessage}
            cswStatus={cswStatus}
            isAllowedToSendMessage={isAllowedToSendMessage}
            recipientId={selectedContact.id}
            phoneId={selectedContact.phoneId}
            recipientNumber={selectedContact.number}
            setMessages={setMessages}
            replyMessage={replyMessage}
            setReplyMessage={setReplyMessage}
          />
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center bg-[#f0f2f5]">
          <div className="text-center">
            <img
              src="https://static.whatsapp.net/rsrc.php/v4/y6/r/wa669aeJeom.png"
              alt="WhatGrowPro"
              className="max-w-md mx-auto mb-8"
            />
            <h1 className="text-3xl text-green-800 font-md mb-3">
              WhatGrowPro
            </h1>
            <p className="text-gray-600">
              Streamline your business communication with WhatGrowPro —
              a smart platform built to help you connect, engage, and grow
              through automated WhatsApp messaging.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatApp;
